import React, { Component } from 'react';
import connect from "react-redux/es/connect/connect";

import FlatButton from "material-ui/FlatButton/index";
import { CardActions } from 'material-ui/Card';
import { NavigationArrowBack } from 'material-ui/svg-icons';
import TextField from 'material-ui/TextField/TextField';
import {Card} from "material-ui/Card/index";
import ViewTitle from "components/layout/ViewTitle";

import * as utils from "./utils";
import {
  updateSwitchFunctionWhitelist as updateSwitchFunctionWhitelistAction,
  clearStateUpdateSwitchFunctionWhitelist as clearStateUpdateSwitchFunctionWhitelistAction,
} from 'actions/advancedFunction';


const cardActionStyle = {
  zIndex: 2,
  float: 'right',
};

class FunctionSwitchRemoveWhitelist extends Component {

  constructor(props) {
    super(props);
    this.onClickSaveButton = this.onClickSaveButton.bind(this);
    this.goBack = this.goBack.bind(this);

    const shopData = JSON.parse(localStorage.getItem(utils.localStoreKeyForShopDataPrepareRemove));
    this.state = {
      shopId: shopData.shop.shop_id,
      shopName: shopData.shop.shop_info.shop_name
    };
  }

  onClickSaveButton() {
    const feature = this.props.match.params.feature;
    const isEPayment = feature === utils.E_PAYMENT_FEATURE_ID + '';
    let data = { shop_feature_setting_packs: [{
        shops: [{shop_id: this.state.shopId}],
        shop_feature_setting: {
          field: feature,
          value: utils.SHOP_ID_NOT_IN_WHITELIST
        }
      }]
    };
    this.props.updateSwitchFunctionWhitelist(data);
  }

  goBack() {
    this.props.history.goBack();
  }

  render() {
    const { updateWhitelistSuccess } = this.props;
    if (updateWhitelistSuccess) {
      this.props.clearStateUpdateSwitchFunctionWhitelist();
      this.goBack();
    }
    const featureName = localStorage.getItem(utils.localStoreKeyForCurrentFeatureName);
    const shopData = JSON.parse(localStorage.getItem(utils.localStoreKeyForShopDataPrepareRemove));
    const shopId = shopData.shop.shop_id;
    const shopName = shopData.shop.shop_info.shop_name;

    return (
      <div className="list-page">
        <Card style={ {padding: '5px'} }>
          <CardActions style={cardActionStyle} >
            <FlatButton primary label={'Back'}
                        onClick={this.goBack}
                        icon={ <NavigationArrowBack />}
            />
          </CardActions>
          <ViewTitle title={`Remove shop - ${featureName}`} />

          <div style={{padding: '20px'}}>
            <TextField floatingLabelText={'Shop ID'} value={shopId} />
            <br />
            <TextField floatingLabelText={'Shop Name'} value={shopName} />
          </div>
          <br />
          <FlatButton primary label='Remove'
                      style={{
                        margin: '5px 12px',
                        position: 'relative',
                      }}
                      onClick={this.onClickSaveButton}
          />
        </Card>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    updateWhitelistSuccess: state.admin.advancedFunction.updateWhitelistSuccess,
  };
}

export default connect(
  mapStateToProps,
  {
    updateSwitchFunctionWhitelist: updateSwitchFunctionWhitelistAction,
    clearStateUpdateSwitchFunctionWhitelist: clearStateUpdateSwitchFunctionWhitelistAction,
  }
)(FunctionSwitchRemoveWhitelist);




// WEBPACK FOOTER //
// ./src/routes/advancedFunction/FunctionSwitchRemoveWhitelist.js